import { SettingOption } from "../../types";
import STORAGE_KEYS from "./storageKeys";

const SETTINGS = {
  BASE_OPTIONS: [
    { id: "2", name: "Call Handling", icon: "laptop", screen: "call-handling" },
    { id: "11", name: "My Device", icon: "Vectorcalling", screen: "my-device" },
    { id: "5", name: "App Settings", icon: "settings", screen: "app-settings" },
    { id: "7", name: "Security", icon: "keys", screen: "security" },
    { id: "8", name: "Tickets", icon: "ticket", screen: "tickets" },
    { id: "9", name: "Dark Mode", icon: "Number", screen: "main" },
    { id: "10", name: "Logout", icon: "logout", screen: "logout" },
  ] as SettingOption[],

  AGENT_OPTIONS: [
    {
      id: "4",
      name: "Assign Addons",
      icon: "schedule",
      screen: "assign-addons",
    },
  ] as SettingOption[],

  USER_OPTIONS: [
    { id: "1", name: "My Numbers", icon: "Number", screen: "my-numbers" },
    { id: "3", name: "Subscription", icon: "schedule", screen: "subscription" },
  ] as SettingOption[],

  PRESERVED_LOGOUT_KEYS: [STORAGE_KEYS.UDID, "alreadyOpenedE911Once"] as const,
};

export default SETTINGS;
